export default class NotificationFormValidation {
	static readonly titleMinLength = 3
	static readonly titleMaxLength = 100

	static readonly contentMinLength = 3
	static readonly contentMaxLength = 200
}
